<template>
    <div class="title">
        <h5>
            {{title}}
        </h5>
    </div>
</template>

<script>
    export default {
        name: 'FileTitle',
        props: {
            title: ''
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';

    .title {
        text-align: left;
        border-bottom: 2px solid $omyfu-red;
        /*margin-bottom: 20px;*/
        padding-top: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/components/shared/FileTitleComponent.vue